/** Labels for usage log cost_source values (future logs list UI). */

const COST_SOURCE_LABELS = {
  local: 'Free',
  provider: 'Provider',
  litellm: 'Calculated',
  rates_litellm: 'Estimated',
  rates_catalog: 'Estimated (catalog)',
  mixed: 'Mixed',
  unknown: 'Unknown',
};

const COST_SOURCE_TOOLTIPS = {
  local: 'Local model — no cloud spend',
  provider: 'Reported by LiteLLM from the provider response',
  litellm: 'Computed by LiteLLM from the completion object',
  rates_litellm: 'Estimated from token counts and LiteLLM rate card',
  rates_catalog: 'Estimated from token counts and synced catalog rates',
  mixed: 'Combined from multiple pricing methods in one request',
  unknown: 'Cost could not be determined',
};

export function formatCostSource(source) {
  if (!source) return null;
  return COST_SOURCE_LABELS[source] || COST_SOURCE_LABELS.unknown;
}

export function costSourceTooltip(source) {
  if (!source) return null;
  return COST_SOURCE_TOOLTIPS[source] || COST_SOURCE_TOOLTIPS.unknown;
}

export function isEstimatedCostSource(source) {
  return ['rates_litellm', 'rates_catalog', 'mixed', 'litellm'].includes(source);
}
